import { render, staticRenderFns } from "./editAnnouncement.vue?vue&type=template&id=b5a7c5e2&scoped=true"
import script from "./editAnnouncement.vue?vue&type=script&lang=js"
export * from "./editAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./editAnnouncement.vue?vue&type=style&index=0&id=b5a7c5e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a7c5e2",
  null
  
)

export default component.exports